// Centralized WhatsApp helper for all CTAs in the site.
// Number provided by client (Brazil): 55 11 91892-2445
export const WHATSAPP_NUMBER = "5511918922445";

export const buildWhatsAppLink = (message) => {
  const text = encodeURIComponent(
    message ||
      "Olá! Vim pelo site da Oasys Academy 2026. Gostaria de conhecer as próximas turmas.",
  );
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};
